import { BonusOverviewSection } from '../../modules/endUserBonusOverview/components/BonusOverviewSection';

export const EndUserBonusOverviewPage = () => {
  return (
    <>
      <BonusOverviewSection />
    </>
  );
};
